const Types = {
    PromotionPortalService: Symbol.for("PromotionPortalService"),
    PromotionPortalServiceConfig: Symbol.for("PromotionPortalServiceConfig"),
    FerryConvenienceApiService: Symbol.for("FerryConvenienceApiService"),
    FerryConvenienceApiServiceConfig: Symbol.for("FerryConvenienceApiServiceConfig"),
};

export { Types };
